import {
	Box,
	Button,
	Container,
	Heading,
	SimpleGrid,
	Text,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
const sections = [
	[
		"/schedule",
		"Посмотреть или назначить работу",
		"Найти день и бригаду, создать блок, перенести работу.",
	],
	[
		"/objects-and-blocks",
		"Найти или добавить объект",
		"Открыть карточку заказа и добавить работы.",
	],
	[
		"/warehouse",
		"Проверить и выдать материалы",
		"Разобраться в остатках, резерве и выдаче.",
	],
	["/brigades", "Добавить бригаду", "Создать группу исполнителей для графика."],
	[
		"/settings",
		"Скачать отчёт или настроить график",
		"Сохранить Excel-файл, включить выходные или часы.",
	],
	[
		"/users-and-roles",
		"Дать сотруднику доступ",
		"Добавить пользователя и разобраться с правами.",
	],
];
export const HomePage = () => (
	<Container maxW="1100px" px={0} py={{ base: 4, md: 6 }}>
		<Text fontSize="sm" fontWeight="bold" color="brand.700" mb={3}>
			ПОМОЩЬ В РАБОТЕ С FLOWTABLE
		</Text>
		<Heading as="h1" size={{ base: "xl", md: "2xl" }} mb={4}>
			Что вы хотите сделать?
		</Heading>
		<Text fontSize="lg" color="gray.600" mb={7} maxW="700px">
			Выберите задачу. Внутри — короткие шаги и снимки экрана с подсказками. Всю
			справку читать не нужно.
		</Text>
		<Box
			p={{ base: 5, md: 7 }}
			mb={7}
			borderRadius="2xl"
			bg="brand.50"
			border="1px solid"
			borderColor="brand.100"
		>
			<Heading as="h2" size="md" mb={2}>
				Первый раз в сервисе?
			</Heading>
			<Text mb={4}>
				Начните со входа. Покажем, где ввести пароль и как найти свою работу.
			</Text>
			<Button as={RouterLink} to="/getting-started" whiteSpace="normal">
				Войти и начать работу →
			</Button>
		</Box>
		<SimpleGrid columns={{ base: 1, md: 2 }} gap={4}>
			{sections.map(([to, title, description]) => (
				<Box
					as={RouterLink}
					to={to}
					key={to}
					p={5}
					border="1px solid"
					borderColor="gray.200"
					bg="white"
					borderRadius="xl"
					_hover={{ borderColor: "brand.400", bg: "brand.50" }}
					_focusVisible={{ outline: "3px solid", outlineColor: "brand.500" }}
				>
					<Heading as="h2" size="sm" mb={2}>
						{title} →
					</Heading>
					<Text color="gray.600">{description}</Text>
				</Box>
			))}
		</SimpleGrid>
		<Box
			mt={7}
			p={5}
			borderLeft="3px solid"
			borderColor="orange.400"
			bg="white"
		>
			<Heading as="h2" size="sm" mb={2}>
				Не получается?
			</Heading>
			<Text mb={3}>
				Не удаётся войти, нет кнопки или пропали работы — начните с простых
				проверок.
			</Text>
			<Button as={RouterLink} to="/troubleshooting" variant="outline">
				Найти решение
			</Button>
			<Button
				as={RouterLink}
				to="/role-scenarios"
				variant="link"
				display="block"
				mt={5}
				whiteSpace="normal"
				textAlign="left"
			>
				Не знаю, с какого раздела начать →
			</Button>
		</Box>
	</Container>
);
